import { useSyncExternalStore } from 'react';
import { decide, getConsent, getServerConsent, subscribe } from './store';
import type { ConsentStatus } from './types';

export type UseConsentResult = {
  status: ConsentStatus;
  isGdprRegion: boolean;
  /** Whether non-essential services may run (off-GDPR, or accepted on GDPR). */
  allowed: boolean;
  hasConsent: boolean;
  hasRejected: boolean;
  isUndecided: boolean;
  /** True once the cookie has been read on the client. */
  hydrated: boolean;
  decide: (status: ConsentStatus) => void;
};

export const useConsent = (): UseConsentResult => {
  const snapshot = useSyncExternalStore(subscribe, getConsent, getServerConsent);

  return {
    status: snapshot.status,
    isGdprRegion: snapshot.isGdprRegion,
    allowed: snapshot.allowed,
    hasConsent: snapshot.status === 'accepted',
    hasRejected: snapshot.status === 'rejected',
    isUndecided: snapshot.status === 'undecided',
    hydrated: snapshot.hydrated,
    decide,
  };
};
